export default __webpack_public_path__ + "static/media/94hive-vertical-logo.3145e3df.png";